<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{ name: 'ckgl_ckcl_dbd' }" style="position: absolute;top: 12px;left: 200px;"><el-button size="mini">回到调拨单</el-button></router-link>

		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 35%;">
					<el-form-item label="订单号"><el-input :disabled="true" v-model="lists.ddh"></el-input></el-form-item>
					<el-form-item label="收款账户">
						<el-select v-model="lists.skzh" placeholder="请选择">
							<el-option :label="item.mc" v-for="(item, index) in sklist" :key="index" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="调拨类型">
						<el-radio-group v-model="lists.dblx">
							<el-radio-button :label="0">同价调拨</el-radio-button>
							<el-radio-button :label="1">异价调拨</el-radio-button>
						</el-radio-group>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="单据类型"><el-input placeholder="调拨单" :disabled="true"></el-input></el-form-item>
					<el-form-item label="业务员">
						<el-select v-model="lists.ywy" filterable style="width: 90%;">
							<el-option v-for="item in ywylist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="调入仓库">
						<el-select v-model="lists.drck" placeholder="请选择">
							<el-option :label="item.name" v-for="(item, index) in cklist" :key="index" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
				<div style="width: 33%;">
					<el-form-item label="备注"><el-input v-model="lists.desc" style="width: 95%;"></el-input></el-form-item>
					<el-form-item label="部门">
						<el-select v-model="lists.bm" filterable style="width: 90%;">
							<el-option v-for="item in bmlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
				</div>
			</div>
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;">
				<div class="m-4 d-flex"><div>仓库明细</div></div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="cgddcp" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }">
						<el-table-column align="center" width="80">
							<template slot="header" slot-scope="scope">
								<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustyl"></el-button>
							</template>
							<template slot-scope="scope" v-if="lists.id == 0">
								<el-button type="danger" size="mini" icon="el-icon-delete" @click="scdel(scope.$index)" ></el-button>
							</template>
						</el-table-column>
						<el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
						<el-table-column prop="cpmc" label="产品名称"></el-table-column>
						<el-table-column prop="cpbm" label="产品编码/sku" align="center"></el-table-column>
						<el-table-column prop="pch" label="批次号" align="center"></el-table-column>
						<el-table-column prop="dcck" label="调出仓库" align="center"></el-table-column>
						<el-table-column prop="drck" label="调入仓库" align="center">
							<template slot-scope="scope">
								<el-select v-model="lists.drck" placeholder="请选择" disabled size="mini">
									<el-option :label="item.name" v-for="(item, index) in cklist" :key="index" :value="item.id"></el-option>
								</el-select>
							</template>
						</el-table-column>
						<el-table-column prop="dw" label="单位" width="50" align="center"></el-table-column>
						<el-table-column label="数量" align="center">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.sl" :max="scope.row.kcsl" @change="handleChange('sl', scope.row.sl, scope.$index)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="单价" align="center">
							<template slot-scope="scope">
								<el-input-number size="mini" disabled v-model="scope.row.dj" :precision="2" @change="handleChange('dj', scope.row.dj, scope.$index)"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="hj" label="合计" align="center">
							<template slot-scope="scope">
								<el-input-number size="mini" disabled v-model="scope.row.hj" :precision="2" @change="handleChange('hj', scope.row.hj, scope.$index)"></el-input-number>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="d-flex m-4">
					<div style="width: 90px;font-size: 14px;">扫码枪录入</div>
					<el-input placeholder="请把鼠标光标定在这里" size="mini"></el-input>
				</div>
			</div>
		</el-form>

		<el-dialog title="选择产品" :visible.sync="createModel" top="5vh" customClass="customWidth">
			<div style="width: 100%;" class="d-flex">
				<el-table
					ref="multipleTable"
					:data="kcmx"
					tooltip-effect="dark"
					style="width: 100%;height: 450px;overflow-y: auto;"
					size="mini"
					@selection-change="handleSelectionChange"
				>
					<el-table-column type="selection" width="50"></el-table-column>
					<el-table-column prop="id" label="编号" width="50" align="center"></el-table-column>
					<el-table-column label="产品图片" width="100" align="center">
						<template slot-scope="scope">
							<img :src="scope.row.cpid.cptp" style="width: 25px;height: 25px;" />
						</template>
					</el-table-column>
					<el-table-column label="产品名称" width="150">
						<template slot-scope="scope">
							{{scope.row.cpid.cpmc}}
						</template>
					</el-table-column>
					<el-table-column label="产品编码" align="center">
						<template slot-scope="scope">
							{{scope.row.cpid.cpbm}}
						</template>
					</el-table-column>
					<el-table-column label="批次号" align="center">
						<template slot-scope="scope">
							{{scope.row.pch}}
						</template>
					</el-table-column>
					<el-table-column label="仓库仓位" align="center">
						<template slot-scope="scope">
							{{scope.row.ckcw.name}}
						</template>
					</el-table-column>
					<el-table-column label="计量单位" align="center" width="80">
						<template slot-scope="scope">
							{{scope.row.dw}}
						</template>
					</el-table-column>
					<el-table-column label="库存数量" align="center">
						<template slot-scope="scope">
							{{scope.row.kcsl}}
						</template>
					</el-table-column>
					<el-table-column label="生产日期" align="center" width="180">
						<template slot-scope="scope">
							{{scope.row.create_time}}
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="1"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submits(multipleSelection)">确 定</el-button>
			</div>
		</el-dialog>

		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;justify-content: center;">
			<el-button type="primary" @click="submit">提交</el-button>
		</el-footer>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/common/mixins/common.js';
export default {
	mixins: [common],
	inject: ['app', 'layout'],
	data() {
		return {
			lists: {},
			sklist: [],
			bmlist: [],
			cklist: [],
			ywylist: [],
			createModel: false,
			preUrl: 'cpgl',
			multipleSelection: [],
			cgddcp: [],
			kcmx:[]
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	// 生命周期
	created() {
		this.lists = this.$route.params.data;
		if(this.lists.id !== 0){
			this.cgddcp = this.$route.params.dbcps;
		}
		this.axios.get('/admin/cangkus', { token: true }).then(res => {
			this.cklist = res.data.data;
		});
		this.axios.get('/admin/bumens/list', { token: true }).then(res => {
			this.bmlist = res.data.data;
		});
		this.axios.get('/admin/cwzj/1', { token: true }).then(res => {
			this.sklist = res.data.data.list;
		});
		this.axios.get('/admin/managers/list', { token: true }).then(res => {
			this.ywylist = res.data.data;
		});
		this.axios.get('/admin/kcmxs', { token: true }).then(res => {
			this.kcmx = res.data.data;
		});
	},
	methods: {
		pustyl() {
			this.createModel = true;
		},
		submits(e) {
			this.cgddcp = e.map(i => {
				return {
					dw: i.dw,
					cpbm: i.cpid.cpbm,
					cpmc: i.cpid.cpmc,
					pch:i.pch,
					dcck:i.ckcw.name,
					sl:0,
					dj:i.cbj,
					hj:0,
					kcid:i.id,
					kcsl:i.kcsl,
					cpid:i.cpid.id,
					cplx:i.cplx,
					ggmc:i.ggmc,
					ggbm:i.ggbm,
					scrq:i.scrq
				};
			});
			console.log(this.cgddcp)
			this.createModel = false;
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		handleChange(lx, e, index) {
			if (lx == 'sl') {
				this.cgddcp[index].hj = this.cgddcp[index].dj * this.cgddcp[index].sl;
			} else if (lx == 'dj') {
				this.cgddcp[index].hj = this.cgddcp[index].dj * this.cgddcp[index].sl;
			} else {
				this.cgddcp[index].dj = this.cgddcp[index].hj / this.cgddcp[index].sl;
			}
			this.lists.spze = 0;
			this.lists.cpsl = 0;
			for (let i of this.cgddcp) {
				this.lists.spze += i.hj;
				this.lists.cpsl += i.sl;
			}
			this.lists.ddje = this.lists.spze;
		},
		//提交
		submit() {
			if (this.cgddcp.length == 0) {
				this.$message({
					type: 'warning',
					message: '请选择调拨的库存'
				});
			} else {
				let x = {
					data: this.lists,
					cpxx: this.cgddcp
				};
				this.layout.showLoading();
				let url = this.lists.id == 0 ? '/admin/kcdbd' : '/admin/kcdbd/' + this.lists.id;
				this.axios
					.post(url, x, {
						token: true
					})
					.then(res => {
						this.$message({
							type: 'success',
							message: !this.lists.id == true ? '下单成功' : '修改成功'
						});
						this.$router.push({
							name: 'ckgl_ckcl_dbd'
						});
						this.layout.hideLoading();
					})
					.catch(err => {
						this.layout.hideLoading();
					});
			}
		},
		scdel(e){
			if(this.cgddcp.length == 1){
				this.cgddcp = []
				this.multipleSelection = []
			}else{
				this.cgddcp.splice(e,1)
				this.multipleSelection.splice(e,1)
			}
			
		}
	}
};
</script>

<style>
.goods_create .el-form-item {
	margin-bottom: 15px;
}
.pt-a {
	padding-top: 20px;
}
</style>
